export const isTeacherUrl = (url: string) => {
  return url.startsWith('/app');
};
